export interface InvoicesDashboardResponse {
  results: InvoicesDashboard[];
  availableFilters: AvailableFilters;
  pageSize: number;
  totalResults: number;
  currentPage: number;
  nextCursor?: string;
}

export interface InvoicesDashboard {
  invoiceId: number;
  invoiceNumber: string;
  referenceNumber: string;
  clientName: string;
  amount: string;
  amountDue: string;
  invoiceDate: string;
  dueDate: string;
  willPay: boolean;
  reason?: string;
  disputedReasonId?: string;
  userText?: string;
  paymentDate?: string;
  urgent?: boolean;
  showWarning?: boolean;
  responseRecieved: boolean;
  company: string;
  age: string;
  statusReason: string;
  status?: string;
}

export interface AvailableFilters {
  statusDebtor?: string[];
  age?: string[];
  carrier?: Carrier[];
}

export interface Carrier {
  clientId: number;
  clientName: string;
}

export interface DisputedReasons {
  id: number;
  statusReasonCodeName: string;
  noteRequired: boolean;
}

export interface Option {
  value: string;
  id: string;
  label?: string;
  defaultSelected?: boolean;
  displayValue?: string;
}

export enum DEFAULT_DATE_FILTER {
  filterIndex = 1,
  filterMonth = 6
}

export const DEFAULT_EXCLUDED_STATUSES = ['Closed', 'Short Paid']
export type ExcludedStatus = typeof DEFAULT_EXCLUDED_STATUSES[number]

export const FILTER_FIELDS = {
  invoiceDate: 'invoiceDate',
  dueDate: 'dueDate',
  status: 'status',
  clientName: 'clientName',
  invoiceNumber: 'invoiceNumber',
  referenceNumber: 'referenceNumber',
  age: 'age',
}

export const DEFAULT_SEARCH_FIELDS = [
  FILTER_FIELDS.invoiceNumber,
  FILTER_FIELDS.referenceNumber,
  FILTER_FIELDS.clientName,
]

export const DATE_RANGE_OPTIONS = [
  { months: 3, index: 0 },
  { months: 6, index: 1 },
  { months: 12, index: 2 },
]

export const isInvoiceSelectable = (invoice: InvoicesDashboard): boolean => {
    return !DEFAULT_EXCLUDED_STATUSES.includes(invoice.status ?? '');
};